/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookmarkIcon24Solid = forwardRef('BookmarkIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 6v14.298c0 1.34-1.467 2.161-2.61 1.462l-4.495-2.752a1.714 1.714 0 0 0-1.79 0L6.61 21.76C5.467 22.46 4 21.637 4 20.298V6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4ZM7.5 6a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Z" })));
});
